import i18n from '@/i18n/i18n'
import { SystemNotificationService } from '@/services/admin/SystemNotificationService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = []

export const namespaced = true

export const state = {
  notifications: [],
  notification: {},
  meta: null
}

export const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications.data
    state.meta = notifications.meta
  },
  SET_NOTIFICATION(state, notification) {
    state.notification = notification
  },
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push(notification)
  },
  DELETE_NOTIFICATION(state, notificationId) {
    state.notifications = state.notifications.filter(notification => notification.id !== notificationId)
  },
  SET_VALUE(state, parameters) {
    state[parameters.type] = parameters.value
  }
}
export const getters = {
  getNotificationById: state => id => {
    return state.notifications ? state.notifications.find(notification => notification.id === id) : false
  }
}

export const actions = {
  setValue({ commit }, parameters) {
    commit('SET_VALUE', parameters)
  },
  getNotifications({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      SystemNotificationService.getNotifications(newQuery)
        .then(response => {
          commit('SET_NOTIFICATIONS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.system_notification.system_notifications')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getNotification({ commit, state, getters }, id) {
    if (id === state.notification.id) return state.notification
    let notification = getters.getNotificationById(id)
    if (notification) {
      commit('SET_NOTIFICATION', notification)
      return notification
    } else {
      return new Promise(resolve => {
        SystemNotificationService.getNotification(id).then(response => {
          commit('SET_NOTIFICATION', response.data)
          resolve(response.data)
        })
      })
    }
  },
  createNotification({ commit, state, dispatch }, notification) {
    return new Promise((resolve, reject) => {
      SystemNotificationService.createNotification(notification)
        .then(response => {
          if (state.notifications) {
            commit('ADD_NOTIFICATION', response.data)
          }
          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('store.admin.system_notification.system_notification')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.system_notification.system_notification')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeNotification({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      SystemNotificationService.deleteNotification(params.id)
        .then(response => {
          commit('DELETE_NOTIFICATION', params.id)
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.system_notification.system_notification')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.not_deleted', {
                element: t('store.admin.system_notification.system_notification')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(true)
        })
    })
  }
}
